import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1e829d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "headerBlock" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = { class: "linkToProjects" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("meer ...")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "serviceItem",
    style: _normalizeStyle({backgroundColor: _ctx.item?.color})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["title", _ctx.item?.name])
        }, _toDisplayString(_ctx.item?.name), 3)
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.item?.description), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          class: "calltoaction",
          to: { name: 'Projects', params: {filter: _ctx.item?.filterName}}
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ], 4))
}